<template>
    <div class="flex flex-col items-center">
        <div class="flex flex-col items-center">
            <h1 class="p-5 text-gamma-blue">Zo werkt het</h1>
            <p class="p-2 font-bold">Jouw soepele verhuizing begint hier. Volg onze eenvoudige stappen om de ideale
                verhuizing te plannen:</p>
            <!--<p class="p-2">Screen width = {{width}}</p>-->
        </div>
        <!-- <div class="flex flex-col md:flex-row justify-between mx-auto mt-10 sticky top-0 z-50">
        <button @click="$router.push({ name: 'Sizes'})" class="bg-gamma-green rounded-xl text-white font-bold text-xl p-10 mr-0 md:mr-10 mb-5 md:mb-0">
            Bereken je verhuizing
        </button>
        <a href="https://meetings.hubspot.com/riksnelleman/meeting-with-team-inbox-storage" target="_blank" class="bg-gamma-blue border-2 border-gamma-blue rounded-xl text-white font-bold text-xl p-10">
            Plan een adviesgesprek
        </a>
    </div> -->

        <div class="hidden md:flex flex-col md:w-3/5 mt-20"><!--MAIN WRAPPER-->
            <div class=" mb-16"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-10">
                        <!-- <div class="flex items-center justify-center -mt-20 w-20 h-20 mx-auto rounded-full bg-gamma-blue">
                    <img src="@/assets/images/how/list_box.png" class="w-7 h-7" />
                </div> -->
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-4 py-1">Stap 1</span></p> Bereken de
                            hoeveelheid
                        </h3>
                    </div>
                    <img src="@/assets/images/how/left_arrow.png" class="absolute right-78 -mt-6 h-32">
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class=" text-sm px-10 font-bold">
                        Gebruik onze handige calculator om te bepalen hoeveel kubieke meter je ongeveer nodig hebt voor
                        al je spullen.
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
            <div class=" mb-16"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-10">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-3 py-1">Stap 2</span></p> Kies je pakket
                        </h3>
                    </div>
                    <img src="@/assets/images/how/left_arrow.png" class="absolute right-78 -mt-3 h-32">
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-10 font-bold">
                        Selecteer een van onze vier verhuispakketten die het beste past bij jouw berekende hoeveelheid
                        past:<br>
                        12m<sup>3</sup>, 24m<sup>3</sup>, 36m<sup>3</sup> of 48m<sup>3</sup>
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
            <div class=" mb-16"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-10">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-3 py-1">Stap 3</span></p> Vul je gegevens in
                        </h3>
                    </div>
                    <img src="@/assets/images/how/left_arrow.png" class="absolute right-78 -mt-6 h-32">
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-10 font-bold">
                        Geef ons je ophaal- en afleveradressen door, en wij zorgen voor een scherpe prijsopgave.
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
            <div class=" mb-16"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-10">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-3 py-1">Stap 4</span></p> Bevestig je verhuizing 
                        </h3>
                    </div>
                 
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-10 font-bold">
                        Bekijk de opmaat gemaakte verwachtte prijsopgave voor je verhuizing en bevestig de reservering
                        middels een aanbetaling van slechts € 1,-!
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
           
            <div class="flex flex-col items-center">
                <p class="p-2 font-bold mb-8">Begin nu en ervaar het gemak van een vlekkeloze verhuizing met Inbox
                    Storage via Gamma.</p>
                <button @click="$router.push({ name: 'Sizes' })"
                    class="bg-gamma-green rounded-3xl text-white font-bold text-xl px-10 py-2 mr-0 md:mr-10 mb-5 md:mb-0">
                    Bereken mijn offerte
                </button>
            </div>


        </div><!--END MAIN WRAPPER-->

        <div class="md:hidden"><!--MOBILE-->

            <div class=" my-3"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-3">
                        <!-- <div class="flex items-center justify-center -mt-20 w-20 h-20 mx-auto rounded-full bg-gamma-blue">
                    <img src="@/assets/images/how/list_box.png" class="w-7 h-7" />
                </div> -->
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-4 py-1">Stap 1</span></p> Bereken de
                            hoeveelheid
                        </h3>
                    </div>
                    <!-- <img src="@/assets/images/how/left_arrow.png" class="absolute right-78 -mt-6 h-32"> -->
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class=" text-sm px-3 font-bold">
                        Gebruik onze handige calculator om te bepalen hoeveel kubieke meter je ongeveer nodig hebt voor
                        al je spullen.
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
            <img src="@/assets/images/how/smallArrowLeft.png" class="mt-2">
            <div class=" my-3"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-3">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-4 py-1">Stap 2</span></p> Kies je pakket
                        </h3>
                    </div>
                 
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-3 font-bold">
                        Selecteer een van onze vier verhuispakketten die het beste past bij jouw berekende hoeveelheid
                        past:<br>
                        12m<sup>3</sup>, 24m<sup>3</sup>, 36m<sup>3</sup> of 48m<sup>3</sup>
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
            <img src="@/assets/images/how/smallArrowLeft.png" class="mt-2">
            <div class=" my-3"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-3">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-4 py-1">Stap 3</span></p> Vul je gegevens in
                        </h3>
                    </div>
                 
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-3 font-bold">
                        Geef ons je ophaal- en afleveradressen door, en wij zorgen voor een scherpe prijsopgave
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->

            
            <img src="@/assets/images/how/smallArrowLeft.png" class="mt-2">
            <div class=" my-3"> <!--ITEM LEFT TITLE-->
                <div class="col w-80"><!--TITLE AND ARROW COL-->
                    <div class="px-3">
                        <h3 class="font-bold leading-9">
                            <p class="mb-2"><span class="bg-gray-300 rounded-2xl px-4 py-1">Stap 4</span></p> Bevestig je verhuizing
                        </h3>
                    </div>
                 
                </div><!--END TITLE AND ARROW COL-->
                <div class=""><!--CONTENT-->
                    <p class="text-sm px-3 font-bold">
                        Bekijk de opmaat gemaakte verwachtte prijsopgave voor je verhuizing en bevestig de reservering
                        middels een aanbetaling van slechts € 1,-!
                    </p>
                </div><!--END CONTENT-->
            </div><!--END ITEM LEFT TITLE-->
           

            <div class="flex flex-col items-center">
                <p class="p-2 font-bold my-8">Begin nu en ervaar het gemak van een vlekkeloze verhuizing met Inbox
                    Storage via Gamma.</p>
                <button @click="$router.push({ name: 'Sizes' })"
                    class="bg-gamma-green rounded-3xl text-white font-bold text-xl px-10 py-2 mr-0 md:mr-10 mb-5 md:mb-0">
                    Bereken mijn offerte
                </button>
            </div>
        </div><!--END MAIN-->
        <div class="flex justify-center mx-auto mt-20 mb-1">
            <a class="text-gray-700 mr-5" href="https://www.inboxstorage.eu/algemene-voorwaarden"
                target="_blank">Algemene voorwaarden</a>
            <a class="text-gray-700 mr-5" href="https://www.inboxstorage.eu/privacy-policy" target="_blank">Privacy
                Policy</a>
            <a class="text-gray-700" href="https://www.inboxstorage.eu/inpakinstructies"
                target="_blank">Inpakinstructies</a>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
    name: 'App',
    components: {
    },
    data() {
        return {
            width: ''
        }
    },
    computed: {
        ...mapState(['currentQuote', 'submitData', 'quotes', 'instantCalculation'])
    },
    methods: {
        ...mapMutations(['changeCurrentStep', 'changePopup']),
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth" // Optional: for smooth scrolling effect
        });
    },
    created() {
        this.changeCurrentStep(0)
        this.changePopup(true)
        this.width = window.innerWidth
    },
}
</script>
